<template>
  <div>
    <div class="video-mask">
      <div>
        <iframe src="https://giphy.com/embed/vFKqnCdLPNOKc" width="120%" height="110%" frameBorder="0"
                class="giphy-embed" allowFullScreen></iframe>
      </div>
    </div>
    <h1>404<br>Pagina niet gevonden</h1>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
};
</script>

<style lang="scss">
</style>
